var PlainString = function PlainString(_ref) {
  var children = _ref.children;
  return children;
};

export default PlainString;